export enum MeasureUnit {
  Gram = 'g',
  Milliliter = 'mL',
}

export enum KeycloakUserRole {
  Admin = 'ROLE_ADMIN',
  SeniorManager = 'ROLE_SENIOR_MANAGER',
  JuniorManager = 'ROLE_JUNIOR_MANAGER',
  PrepManager = 'ROLE_PREP_MANAGER',
  Expert = 'ROLE_EXPERT',
  PrepExpert = 'ROLE_PREP_EXPERT',
  ExpertManager = 'ROLE_EXPERT_MANAGER',
  PrepExpertManager = 'ROLE_PREP_EXPERT_MANAGER',
  SilverMember = 'ROLE_SILVER_MEMBER',
  BronzeMember = 'ROLE_BRONZE_MEMBER',
}
